import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';
import { ClientService } from '../../@core/data/clients/client.service';
import { ClientsError, ClientsLoaded, ClientsRequested } from './clients.actions';
import { NbToastrService } from '@nebular/theme';
import { ToastrConfigs } from '../../@core/data/toastr-config';
import { LoggedUserLoaded } from '../users/users.actions';
import { IClientsState } from './clients.state';
import { withLatestFrom, filter } from 'rxjs/operators';
const _ = require('lodash');

@Injectable()
export class ClientsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAppState>,
    private toastrService : NbToastrService,
    private clientService: ClientService
  ) {}

  requestClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientsRequested),
      mergeMap((props) =>
        this.clientService.getClientsRedux(props.userId).pipe(
          map((response: {status:boolean, data:IClientsState['clients']}) => {
            if (response.status){
              return ClientsLoaded({ clients: response.data });
            }
            return ClientsLoaded({ clients: [] });
          }),
          catchError((error: any) => of(ClientsError()))
        )
      )
    )
  );

  requestClietsAfterUserLogged$ = createEffect(() => 
    this.actions$.pipe(
      ofType(LoggedUserLoaded),
      map((props)=> ClientsRequested({userId: props.loggedUser.user_id}))
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ClientsError),
        tap(() => {
          this.toastrService.show(`Lista clienților nu este disponibilă în acest moment!`, `Eroare`, ToastrConfigs.danger);
        })
      ),
    { dispatch: false }
  );
}
